<template>
    <div class="lineAddContainer">
        <div>
        <el-form :inline="true" :model="formInline" size="mini">
            <el-form-item label="老系统线路名称">
                <el-select v-model="form.lineId" filterable placeholder="请选择">
                    <el-option v-for="item in oldLine" :key="item.lineId" :label="item.lineName" :value="item.lineId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="新系统出发地">
                <el-select v-model="form.startAreaId" filterable placeholder="请选择">
                    <el-option v-for="item in startAreaList" :key="item.areaManageId" :label="item.areaName" :value="item.areaManageId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="新系统目的地">
                <el-select v-model="form.endAreaId" filterable placeholder="请选择">
                    <el-option v-for="item in endAreaList" :key="item.areaManageId" :label="item.areaName" :value="item.areaManageId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="searchClick">筛选</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="resetClick">清空</el-button>
            </el-form-item>
        </el-form>
        </div>
        <el-button class="add" type="primary" size="mini" @click="addClick">新增路线</el-button>
    </div>
</template>

<script>
import { to } from '@/util/util'
import { getLineConfigEnums, getOldLineEnum } from '@/api/line/line'

export default {
    props: {
        startAreaList: {
            type: Array,
            default: () => []
        },
        oldLine: {
            type: Array,
            default: () => []
        },
        endAreaList: {
            type: Array,
            default: () => []
        },
    },
    
    data() {
        
        return {
            startAreaList: [],
            oldLine: [],
            endAreaList: [],
            form: {
                lineId: '',
                lineName: '',
                startAreaId: '',
                startAreaName: '',
                endAreaId: '',
                endAreaName: '',
            }
        }
    },
    methods: {
        // 清空选择表单
        resetClick() {
            this.form = {}
            this.$emit('reset')
        },
        // 筛选
        searchClick() {
            this.$emit('search', this.form)
        },
        // 新增路线
        addClick() {
            this.$emit('add')
        },
    }
}
</script>

<style lang="scss" scoped>
.lineAddContainer{
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.add{
    margin-top: -17px;
    margin-right: 40px;
    
}
</style>